<body>
  <div class="container">
    <router-outlet></router-outlet>
  </div>

</body>
<footer class="my-5 pt-5 text-muted text-center text-small">
  <p class="mb-1">© 2023 Hércules Formación</p>
</footer>
<p-toast position="bottom-center" key="bc"></p-toast>